import isEqual from 'lodash/isEqual';

export const checkArraysContainSameItems = (a?: string[], b?: string[]) => {
  if (a?.length !== b?.length) {
    return false;
  }

  return isEqual(new Set(a), new Set(b));
};
